<template>
  <v-card
    style="width: 100% !important; height: 100% !important; overflow: auto"
  >
    <v-toolbar dense flat>
      <v-toolbar-title v-if="!loading">{{ label }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text
      class="text-left table-borders"
      v-html="value"
      v-if="!loading"
    ></v-card-text>
    <template v-if="loading">
      <v-card-text>
        <v-progress-linear indeterminate color="accent"></v-progress-linear>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "TextCard",
  props: ["label", "value", "loading"],
};
</script>

<style>
.table-borders > table td,
.table-borders > table th {
  min-width: 4em;
  border: 1px solid #ddd;
  padding: 3px 5px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.table-borders > pre {
  padding: 0.7rem 1rem;
  border-radius: 5px;
  background-color: rgb(47, 46, 44);
  font-size: 1rem;
}
</style>
